import { shopwareApiClient } from '$lib/api/shopwareApi.js';
import type { ApiRequestParams, ApiReturnType } from '$lib/api/shopwareApi.js';
import type { ShopContext } from '$lib/context.js';

export class CartApi {
    public static getCart(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'readCart'>> {
        return shopwareApiClient.invoke(
            'readCart get /checkout/cart?name',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }

    public static addLineItem(
        data: ApiRequestParams<'addLineItem'>,
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'addLineItem'>> {
        return shopwareApiClient.invoke('addLineItem post /checkout/cart/line-item', data, {
            fetchImplementation,
            shopContext
        });
    }

    public static updateLineItem(
        data: ApiRequestParams<'updateLineItem'>,
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'updateLineItem'>> {
        return shopwareApiClient.invoke('updateLineItem patch /checkout/cart/line-item', data, {
            fetchImplementation,
            shopContext
        });
    }

    public static removeLineItem(
        data: ApiRequestParams<'removeLineItem'>,
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'removeLineItem'>> {
        return shopwareApiClient.invoke('removeLineItem delete /checkout/cart/line-item?ids', data, {
            fetchImplementation,
            shopContext
        });
    }
}
